import React, { useState } from "react";
import Profile from "./Profile/profile";
import Password from "./Password/password";
import { User, KeyRound } from "lucide-react";

const Account = () => {
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("accountSegment") || "Profile"
  );

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    localStorage.setItem("accountSegment", tab);
  };

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-800">Account Settings</h1>
        <p className="text-slate-500 mt-1">Manage your profile details and security preferences.</p>
      </div>
      
      {/* Modern Tab Pill Navigation */}
      <div className="flex bg-slate-100 p-1 rounded-xl w-fit border border-slate-200">
        <button
          onClick={() => handleTabChange("Profile")}
          className={`flex items-center gap-2 px-6 py-2.5 rounded-lg text-sm font-medium transition-all ${
            activeTab === "Profile" 
              ? "bg-white text-blue-600 shadow-sm border border-slate-200/50" 
              : "text-slate-500 hover:text-slate-800"
          }`}
        >
          <User className="w-4 h-4" /> Profile
        </button>
        <button
          onClick={() => handleTabChange("Password")}
          className={`flex items-center gap-2 px-6 py-2.5 rounded-lg text-sm font-medium transition-all ${
            activeTab === "Password" 
              ? "bg-white text-blue-600 shadow-sm border border-slate-200/50" 
              : "text-slate-500 hover:text-slate-800"
          }`}
        >
          <KeyRound className="w-4 h-4" /> Security
        </button>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
        {activeTab === "Profile" ? <Profile /> : <Password />}
      </div>
    </div>
  );
};

export default Account;